import moment from 'moment';

const calculateNights = (startDate, endDate) => {
  const differenceDays = moment(endDate).diff(moment(startDate), 'days');

  return differenceDays;
};

export const getTotalCost = (costPerNight, orderDates) => {
  const startDate = orderDates.startDate;
  const endDate = orderDates.endDate;

  const totalCost = startDate && endDate && new Date(startDate).getTime() < new Date(endDate).getTime()
    ? costPerNight * calculateNights(startDate, endDate)
    : 0;

  return totalCost;
};

// Place item on TimeLine always at the center (12:00) regardless of the clicked point.
export const fitTimeInDate = (date) => { // TODO: dateType?
  const time = 0o5; //dateType?.isEndDay ? 12 : 0o1;

  date.setHours(time);
  date.setMinutes(0);
  date.setSeconds(0);

  return date;
};

// -- TimeLine - get end date

// const formatDate = (date) => {
//   const day = date.getDate();
//   const month = date.getMonth() + 1;
//   const year = date.getFullYear();
  
//   return `${year}-${month}-${day}`;
// };

// const isDateExistInOrdersData = (ordersData, date, propertyId) => {
//   const formattedDateTo = formatDate(date);

//   return ordersData.some(order => {
//     const orderDate = new Date(order.dateFrom);
//     const formattedOrderDate = formatDate(orderDate);

//     return formattedOrderDate === formattedDateTo && order.propertyId === propertyId;
//   });
// }

// // If the next day of clicked day is reserved, return same date as "dateTo" or +1 day if the next day is available
// export const getTimeLineEndDate = (ordersData, clickedDay, clickedPropertyId) => {
//   let dateTo = addOneDayToDate(clickedDay);

//   if (isDateExistInOrdersData(ordersData, clickedDay, clickedPropertyId)) { // if next day from clicked is reserved
//     dateTo = clickedDay;
//   }

//   return dateTo;
// }
